import React from 'react';
import typography from '../../utils/typography';
import { useTheme } from '@veneer/theme';
import { SerializedStyles, css } from '@emotion/core';

const useStyles = (): {
  root: {
    base: SerializedStyles;
    rtl: SerializedStyles;
  };
  action: SerializedStyles;
  closeButton: SerializedStyles;
  title: {
    base: SerializedStyles;
    description: SerializedStyles;
  };
} => {
  const theme = useTheme();

  return React.useMemo(
    () => ({
      root: {
        base: css({
          alignItems: 'flex-start',
          borderRadius: theme.borderRadius,
          borderStyle: 'solid',
          borderWidth: 1,
          boxSizing: 'border-box',
          display: 'flex',
          fontFamily: theme.typography.family0,
          padding: `0 calc(${theme.orbitalTwo} - 1px) 0 calc(${theme.orbitalThree} - 1px)`,
          width: '100%',
        }),
        rtl: css({
          padding: `0 calc(${theme.orbitalThree} - 1px) 0 calc(${theme.orbitalTwo} - 1px)`,
        }),
      },
      action: css({
        margin: `calc(${theme.orbitalTwo} - 2px) 0`,
      }),
      closeButton: css({
        margin: `${theme.orbitalTwo} 1px ${theme.orbitalTwo} 0px`,
      }),
      title: {
        base: css({
          display: 'flex',
          flex: '1',
          flexDirection: 'column',
          margin: `calc(${theme.orbitalThree} - 1px) ${theme.orbitalThree} calc(${theme.orbitalThree} - 1px) ${theme.orbitalOne}`,
          wordBreak: 'break-word',
          ...typography(theme).label,
          minHeight: theme.layout.size6,
          justifyContent: 'center',
        }),
        description: css({
          minHeight: `calc(${theme.layout.size6} + ${theme.layout.size4})`,
        }),
      },
    }),
    [theme]
  );
};

export default useStyles;
